// eslint-disable-next-line no-unused-vars
import countdown from 'jquery-countdown';

class Countdown {
  constructor() {
    this.timer();
  }

  timer() {
    if (!document.querySelector('[data-countdown]')) {
      return;
    }

    const timerEl = $('[data-countdown]');

    const dispatchTime = timerEl.parent().data('dispatch-time');
    const dispatchMessageEl = timerEl.parent().data('dispatch-messages');
    const dispatchMessages = {
      firstTitle: dispatchMessageEl[0],
      beforeDispatchMsg: dispatchMessageEl[1],
      secondTitle: dispatchMessageEl[2],
      afterDispatchMsg: dispatchMessageEl[3],
    };

    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();
    const todayDate = `${mm}/${dd}/${yyyy} ${dispatchTime}`;

    timerEl.countdown(todayDate, function(event) {
      const firstTitle = `<p class="text-with-icons__title text--strong">${dispatchMessages.firstTitle}</p>`;

      const beforeDispatchMsg = `
        <div class="text-with-icons__content rte">
          <p>${dispatchMessages.beforeDispatchMsg.replace('[timer]', event.strftime('%H:%M:%S'))}</p>
        </div>
      `;
      $(this).html(`${firstTitle} ${beforeDispatchMsg}`);
      if (event.elapsed) {
        const secondTitle = `<p class="text-with-icons__title text--strong">${dispatchMessages.secondTitle}</p>`;
        const afterDispatchMsg = `
            <div class="text-with-icons__content rte">
              <p>${dispatchMessages.afterDispatchMsg.replace('[timer]', event.strftime('%H:%M:%S'))}</p>
            </div>
          `;
        $(this).html(`${secondTitle} ${afterDispatchMsg}`);
      }
    })

      .on('finish.countdown', function(evt) {
        const secondTitle = `<p class="text-with-icons__title text--strong">${dispatchMessages.secondTitle}</p>`;
        const afterDispatchMsg = `
          <div class="text-with-icons__content rte">
            <p>${dispatchMessages.afterDispatchMsg.replace('[timer]', evt.strftime('%H:%M:%S'))}</p>
          </div>`;
        $(this).html(`${secondTitle} ${afterDispatchMsg}`);
      });
  }
}

export default Countdown;
